<template>
    <v-dialog
        :value="value"
        max-width="1000px"
        scrollable
        @input="$emit('input', $event)"
        @keydown.enter.prevent="save"
        @keydown.esc.prevent="cancel"
    >
        <v-card :loading="loading" :disabled="disabled">
            <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ location ? $t('edit_location') : $t('create_location') }}</span>
            </v-card-title>
            <v-card-text style="max-height: var(--usable-dialog-height)">
                <light-toolbar dense>
                    <v-toolbar-title>
                        <LegalTypeIcon :address-record="location" class="mr-1" />
                        <span v-if="location.legal_type === 'person'">{{ $t('person') }}: </span>
                        <span v-else-if="location.legal_type === 'organization'">{{ $t('organization') }}: </span>
                        <span v-else>({{ $t('no_type') }}): </span>
                        <strong>{{
                            location.title || `${location.first_name ?? ''} ${location.surname ?? ''}`
                        }}</strong>
                    </v-toolbar-title>

                    <v-spacer />

                    <KpIcon :icon-cls="location.status_icon" :color="location.status_icon_color" left />
                    <span class="grey--text">{{ location.humanReadableStatus }}</span>
                </light-toolbar>
                <KpAlert v-if="!writable" class="mt-5" type="warning">
                    Du kannst diese Lokation nicht bearbeiten: Du hast keinen Schreib-Zugriff auf diese Lokation.
                </KpAlert>
                <EditForm
                    ref="editForm"
                    :location="location"
                    :organizer-id="organizerId"
                    :writable="writable"
                    @input="isValid = $event"
                    @loading="loading = $event"
                    @location-changed="$emit('location-changed', $event)"
                    @address-changed="$emit('address-changed', $event)"
                    @location-added="$emit('location-added', $event)"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <PlainBtn text :to="{ name: 'address-edit', params: { id: location.address_id } }" target="_blank">{{
                    $t('open_in_new_tab')
                }}</PlainBtn>
                <PlainBtn text @click="cancel">{{ $t('cancel') }}</PlainBtn>
                <ActionBtn :loading="saving" :disabled="!isValid" @click="save">{{ $t('save') }}</ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EditForm from '@/components/location/EditForm.vue';
import { Location } from '@/models/Location';
import { errToStr } from '@/helpers/tools';
import { mapActions } from 'vuex';
import LegalTypeIcon from '../address/LegalTypeIcon.vue';

export default {
    name: 'LocationEditDialog',
    components: {
        EditForm,
        LegalTypeIcon,
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        location: {
            type: Location,
            default: null,
        },
        organizerId: {
            type: Number,
            default: null,
        },
        writable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            saving: false,
            loading: false,
            isValid: false,
        };
    },

    computed: {
        disabled() {
            return this.loading || this.saving;
        },
    },

    methods: {
        ...mapActions(['runAsync']),

        async save() {
            this.saving = true;
            try {
                await this.runAsync(async () => await this.$refs.editForm.save());
                this.$emit('input', false);
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            } finally {
                this.saving = false;
            }
        },

        cancel() {
            this.$emit('input', false);
        },
    },
};
</script>

<style lang="scss" scoped></style>
